/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Select from 'bee-select';
import { hasValue, hasBackSpaceClear } from './util';
import { isArrowKeyDown } from '../../public';

require('./index.less');
require('bee-select/build/Select.css');

const Option = Select.Option;

class NCSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: this.props.open
		};
	}

	componentDidMount() {
		/*
		* 如果业务组传入supportSearch -> 则支持输入
		* */
		let { supportSearch = false } = this.props;
		let inputEl = this.selectInput
			&& this.selectInput.querySelector('input.u-select-search-field');

		inputEl
			&& supportSearch === false
			&& inputEl.setAttribute('readonly', 'readonly');
		inputEl = null;

		this.selectInput.addEventListener('click', this.handleInputClick);
	}

	componentWillUnmount() {
		// 移除document事件
		document.removeEventListener('click', this.close);
		this.selectInput = null;
	}

	// keyDown
	keyDownHandler = (e) => {
		// 只有一個  e對象  不過應該夠用了
		// enter 键
		if (e.keyCode === 13) {
			this.props.onEnter && this.props.onEnter({ e });
		}

		if (e.key === 'Backspace' && hasBackSpaceClear(this.props)) {
			this.handleClear();
		}

		this.actionWithHotKey(e);
	};

	close = e => {
		const { onBlur, value } = this.props;

		if (this.open && this.select && !this.select.contains(e.target)) {
			let timer = setTimeout(() => {
				typeof onBlur === 'function' && onBlur(value);
				this.open = false;
				clearTimeout(timer);
			}, 0);
		}
	};

	handleClear = (e) => {
		//点击下拉框时触发table的rowClick事件 NCCLOUD-151231
		e && e.stopPropagation();

		let { onFocus, value } = this.props;

		if (typeof onFocus === 'function') {
			let result = onFocus(value);

			if (result instanceof Promise) {
				result.then(isContinue => {
					if (isContinue !== false) {
						this.clear();
					}
				});
			} else if (result !== false) {
				this.clear();
			}

		} else {
			this.clear();
		}

	};

	clear = () => {
		let { onChange, onSelect, onBlur, multiple } = this.props;
		typeof onChange === 'function' && onChange(undefined);
		typeof onSelect === 'function' && onSelect(undefined);
		typeof onBlur === 'function' && onBlur(multiple ? [] : undefined);

		//把标识设为默认值
		this.clickIcon = false;
	};

	onFocus = val => {
		const { onFocus, isTable } = this.props;
		this.open = true;
		let dom = null;
		if (isTable) {
			dom = {};
		} else {
			if (
				this.select &&
				this.select.getElementsByClassName &&
				Array.isArray(this.select.getElementsByClassName('nc-select'))
			) {
				dom = this.select.getElementsByClassName('nc-select')[0];
			}
		}
		typeof onFocus === 'function' && onFocus(val, dom);
	};

	onChange = val => {
		const { onChange, value, onOpenChange, multiple } = this.props;
		this.open = true;
		typeof onChange === 'function' && onChange(val, value);
		// setTimeout  表格侧拉模式控制 下拉框的  展开收起  by bbqin
		!multiple && onOpenChange && onOpenChange(false);
	};

	onBlur = (val) => {
		this.open = false;
		const { onBlur } = this.props; // zhanghengh加 ， 否则有bug
		typeof onBlur === 'function'
			&& this.clickIcon !== true
			&& onBlur(val ? [] : undefined);
	};

	/**
	 *
	 * @param e {obj} 事件源
	 */
	handleContainerMouseDown = (e) => {
		//点击下拉框时触发table的rowClick事件 NCCLOUD-151231
		e.stopPropagation();
		/*
		* @desc: 点击清空按钮会触发onblur事件，在表格中触发onBlur会切换浏览状态，
		* @resolve：在鼠标点击时判断一下点击的元素是不是清空按钮
		* */

		if (e.target.className.includes('select-icon')) {
			this.clickIcon = true;
		} else {
			this.clickIcon = false;
		}
	};

	handleInputKeyDown = (e) => {
		let { onInputKeyDown } = this.props;
		if (e.key === 'Backspace' && hasBackSpaceClear(this.props)) {
			this.handleClear();
		}
		this.actionWithHotKey(e);

		onInputKeyDown && onInputKeyDown(e);
	};

	handleInputClick = () => {
		let { renderInTable } = this.props;
		if (renderInTable) {
			this.setState({
				open: !this.state.open
			});
		}
	};

	handleSelect = (value, ref) => {
		let { onSelect, renderInTable, multiple } = this.props;
		typeof onSelect === 'function' && onSelect(value, ref);

		if (renderInTable && multiple !== true) {
			this.setState({
				open: false
			});
		}
	};

	actionWithHotKey = (e) => {
		let { open } = this.state;
		let { renderInTable, hotKeyWithArrow, onOpenChange } = this.props;
		//control键 打开下拉面版
		if (e.keyCode === 17 && renderInTable) {
			this.setState({ open: !open });
		}

		//表格中按esc 直接关闭
		if (e.keyCode === 27 && renderInTable) {
			this.setState({ open: false });
		}

		if (isArrowKeyDown(e, [37, 39])) {
			hotKeyWithArrow && hotKeyWithArrow({ e });
		}

		if (renderInTable && open !== true && isArrowKeyDown(e)) {
			hotKeyWithArrow && hotKeyWithArrow({ e });
		}

		//按下esc
		if (!renderInTable && e.keyCode === 27) {
			onOpenChange && onOpenChange(false);
		}
	};

	render() {
		let { className, showStar, onBlur, onFocus, onClick, onChange, fieldid, popData, enterKeyDown = false, multiple, supportSearch, renderInTable, ...others } = this.props;
		if (!popData && fieldid) {
			popData = { 'fieldid': `${fieldid}_select` };
		}

		let multiClassName = multiple ? 'nc-select-multi' : '';
		let cursorClassName = supportSearch ? 'nc-select-search-pointer' : 'nc-select-pointer';

		let controlOpenObj = {};
		if (renderInTable) {
			controlOpenObj.open = this.state.open;
			controlOpenObj.onSelect = this.handleSelect;
		}

		return (
			<div
				className={`u-form-control-wrapper nc-select-wrapper ${className} ${cursorClassName}`}
				ref={dom => {
					this.select = dom;
				}}
				fieldid={fieldid || null}
				onMouseDown={this.handleContainerMouseDown}
				onClick={(e) => {
					e.stopPropagation();
				}}
			>
				{showStar ? <span className="select-required-tag">*</span> : ''}

				<Select
					popData={popData}
					className={`nc-select ${className} ${multiClassName}`}
					onFocus={this.onFocus}
					onChange={this.onChange.bind(this)}
					onBlur={this.onBlur.bind(this)}
					// 如果设置了 autofocus  会导致跳转不出去的情况  需要注意的是 外部可能会传入autofocus  TODO  --bbqin
					ref={selectInput => {
						this.selectInput = ReactDOM.findDOMNode(selectInput); // 获取到组件对象 -- bbqin
					}}
					onKeyDown={this.keyDownHandler}
					enterKeyDown={enterKeyDown}
					maxTagCount={1}
					multiple={multiple}
					{...others}
					maxTagPlaceholder={(tags) => {
						return '+' + tags.length;
					}}
					notFoundContent={<div>&nbsp;</div>}
					// dropdownMatchSelectWidth={false}
					onDeselect={this.props.onDeselect}
					onInputKeyDown={this.handleInputKeyDown}
					{...controlOpenObj}
				>
					{this.props.children}

				</Select>

				{
					!others.disabled
						&& others.required !== true
						&& others.showClear === true
						&& hasValue(others.value)
						&& (
						<i
							className="iconfont icon-qingkong select-icon"
							onClick={this.handleClear}
							style={{ right: '20px' }}
						/>
					)
				}
			</div>
		);
	}
}

NCSelect.defaultProps = {
	showClear: true
};

NCSelect.NCOption = Option;

export default NCSelect;
